import 'core/assets/styles/style.css'
import Loader from 'core/components/common/Loader'
import { Error403 } from 'core/components/error/Error403'
import { Error404 } from 'core/components/error/Error404'
import { Error500 } from 'core/components/error/Error500'
import ErrorHandler from 'core/components/error/ErrorHandler'
import { LayoutWrapper } from 'core/components/layout/LayoutWrapper'
import { BACKOFFICE_PATH, ROUTE_PATHS } from 'core/constants/routePath'
import { UserContext } from 'core/contexts/UserContext'
import { UseKeycloakService } from 'core/packages/KeycloakProvider'
import { Layout } from 'core/pages/Layout'
import store, { persistor, RootState } from 'core/store'
import { IaStart } from 'iastart/pages/IaStart'
import { IaStartApps } from 'iastart/pages/IaStartApps'
import { ModelesLLMProvider } from 'lauria/contexts/ModelesLLMContext'
import { ApplicationEdition } from 'lauria/pages/applications/ApplicationEdition'
import { LayoutApplication } from 'lauria/pages/applications/LayoutApplication'
import { Dashboard } from 'lauria/pages/Dashboard'
import { ProfileEdition } from 'lauria/pages/profiles/ProfileEdition'
import { Profiles } from 'lauria/pages/profiles/Profiles'
import { Kpi } from 'lauria/pages/prompts/Kpi'
import { PromptEdition } from 'lauria/pages/prompts/PromptEdition'
import { PromptList } from 'lauria/pages/prompts/PromptList'
import { Prompts } from 'lauria/pages/prompts/Prompts'
import { Tags } from 'lauria/pages/Tags'
import { useContext } from 'react'
import { Provider, useSelector } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'

function App() {
  const kc = UseKeycloakService()
  const { businessStatus } = useContext(UserContext)
  const errorCode = useSelector((state: RootState) => state.error.code)

  const isLoading = !kc.isInitialized() || businessStatus === 'loading'

  if (isLoading) {
    return (
      <Loader center className="h-screen flex items-center justify-center" />
    )
  }

  // En cas d'erreur au bootstrap (UserContext), on court-circuite les routes
  // métier (qui supposent un user non nul) tout en conservant un contexte
  // <BrowserRouter> : le LayoutHeader utilise useNavigate / useLocation.
  if (businessStatus === 'error') {
    const ErrorComponent = errorCode === 403 ? Error403 : Error500
    return (
      <BrowserRouter>
        <LayoutWrapper layoutClassName="layout-container">
          <div className="outlet-container items-center">
            <ErrorComponent />
          </div>
        </LayoutWrapper>
      </BrowserRouter>
    )
  }

  const {
    APPLICATION_CREATION,
    APPLICATION_EDITION,
    PROFILES,
    PROFILES_EDIT,
    PROMPTS,
    PROMPT_CREATE,
    PROMPT_EDIT,
    ERROR,
    ERROR_403,
    ERROR_404,
    TAG_ADMIN,
    KPI,
    IASTART,
    IASTART_APP,
  } = ROUTE_PATHS

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ModelesLLMProvider>
          <BrowserRouter>
            <ErrorHandler>
              <Routes>
                <Route path={BACKOFFICE_PATH}>
                  <Route path="" element={<Layout displayProfileIcone />}>
                    <Route path="" element={<Dashboard />} />
                    <Route path={TAG_ADMIN} element={<Tags />} />
                    <Route path={PROFILES} element={<Profiles />} />
                    <Route path={PROFILES_EDIT} element={<ProfileEdition />} />
                    <Route
                      path={APPLICATION_CREATION}
                      element={<ApplicationEdition />}
                    />
                    <Route
                      path={APPLICATION_EDITION}
                      element={<ApplicationEdition />}
                    />
                  </Route>
                  <Route path="" element={<LayoutApplication />}>
                    <Route path={PROMPTS} element={<Prompts />}>
                      <Route index element={<PromptList />} />
                      <Route path={KPI} element={<Kpi />} />
                    </Route>
                    <Route path={PROMPT_EDIT} element={<PromptEdition />} />
                    <Route path={PROMPT_CREATE} element={<PromptEdition />} />
                  </Route>
                </Route>
                <Route path="" element={<Layout />}>
                  <Route path={IASTART} element={<IaStart />} />
                  <Route path={IASTART_APP} element={<IaStartApps />} />
                </Route>
                <Route element={<Layout itemsCenter />}>
                  <Route path={ERROR} element={<Error500 />} />
                  <Route path={ERROR_403} element={<Error403 />} />
                  <Route path={ERROR_404} element={<Error404 />} />
                  <Route path="*" element={<Error404 />} />
                </Route>
              </Routes>
            </ErrorHandler>
          </BrowserRouter>
        </ModelesLLMProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
